import { useEffect, useState } from 'react'
import axios from 'axios';
import Main from '../../component/Main';
import Loading from '../../component/common/loading/Loading';
import HomeBoard from './HomeBoard';
import BarLineMixChart from './bar_line_mix_chart';
import BarChart from './bar_chart';
import DoughnutChart from './doughnut_chart';
import { useIs17Inch } from '../../hooks/useBreakPoint';

import '../../css/home.css'
import * as Icons from '../../images/icons/icons_component'
import * as Theme from '../../images/icons/icons_theme';

const NewHome = () => {

    const [data, setData] = useState([{}]);
    const [dayData, setDayData] = useState([{}]);
    const [monthData, setMonthData] = useState([{}]);
    const [yearData, setYearData] = useState([{}]);
    const [isLoading, setIsLoading] = useState(false);
    const [isMonthLoading, setIsMonthLoading] = useState(false);
    const [isYearLoading, setIsYearLoading] = useState(false);

    const [termTab, setTermTab] = useState('day');
    const termTabName = [
        { en: 'day', kr: '일별' }, { en: 'month', kr: '월별' }, { en: 'year', kr: '연도별' }
    ]

    const useremcd = localStorage.getItem('useremcd');
    const userauth = localStorage.getItem('userAuth');

    const admin = userauth === 'J001' || userauth === 'J002';
    const loading = termTab === 'day' ? isLoading : termTab === 'month' ? isMonthLoading : isYearLoading;

    const ptmiTransferCnt = async () => {
        try {
            if(admin) {
                const response = await axios.get('/ptmiapi/getHomeChartData.do',
                    { params: { userauth: userauth } }
                );
                setData(response.data);
            } else {
                const response = await axios.get('/ptmiapi/getHomeChartMyData.do',
                    { params: { useremcd: useremcd, userauth: userauth } }
                );
                setData(response.data);
            }
            setIsLoading(false);
        } catch (e) {
            console.error('today data 로딩 중 오류 발생', e);
        }
    }

    const ptmiTransferDayCnt = async () => {
        try {
            const response = await axios.get('/ptmiapi/getHomeChartDayData.do',
                { params: { useremcd: useremcd, userauth: userauth } }
            );
            setDayData(response.data);
        } catch (e) {
            console.error('chart day data 로딩 중 오류 발생', e);
        }
    }

    const ptmiTransferMonthCnt = async () => {
        try {
            const response = await axios.get('/ptmiapi/getHomeChartMonthData.do',
                { params: { useremcd: useremcd, userauth: userauth } }
            );
            setMonthData(response.data);
            setIsMonthLoading(false);
        } catch (e) {
            console.error('chart month data 로딩 중 오류 발생', e);
        }
    }

    const ptmiTransferYearCnt = async () => {
        try {
            const response = await axios.get('/ptmiapi/getHomeChartYearData.do',
                { params: {useremcd: useremcd, userauth: userauth} }
            );
            setYearData(response.data);
            setIsYearLoading(false);
        } catch (e) {
            console.error('chart year data 로딩 중 오류 발생', e);
        }
    }

    useEffect(() => {
        setTermTab('day');
        ptmiTransferCnt();
        setIsLoading(true);
        ptmiTransferDayCnt();
        setIsMonthLoading(true);
        ptmiTransferMonthCnt();
    }, []);

    useEffect(() => {
        const timeout = setTimeout(() => {
             setIsYearLoading(true);
             ptmiTransferYearCnt();
        }, 800);

        return () => clearTimeout(timeout);
    }, []);

    // 차트 새로고침
    const refresh = (termTab) => {
        if (termTab === 'day') {
            ptmiTransferCnt();
            setIsLoading(true);
            ptmiTransferDayCnt();
        } else if (termTab === 'month') {
            ptmiTransferCnt();
            setIsMonthLoading(true);
            ptmiTransferMonthCnt();
        } else {
            ptmiTransferCnt();
             setIsYearLoading(true);
             ptmiTransferYearCnt();
        }
    }

    const is17Inch = useIs17Inch();

    return (
        <Main>
            <div className='home_wrapper'>
                <div className='chart_container'>
                    <div className='mix_chart_wrapper'>
                        <div className='chart_title'>
                            <Icons.HomeIcoChart /> 전송건수
                        </div>
                        <div className='mix_chart_box'>
                            <>
                                <div className='flex gap-5'>
                                    {data.todayCntList?.map((item, idx) => 
                                        <div key={idx} className='today_box'>
                                            <h2 className='today_title'>{item.PTMIINDT}</h2>
                                            {admin ? 
                                            <div className='flex justify-center text-center'>
                                                <h3 className='today_value'>{item.CNT}</h3>
                                                <h3 className='today_all'>건</h3>
                                            </div>
                                            :
                                            <div className='flex justify-center text-center gap-1'>
                                                <span className='today_org'>{dayData.livingArea?.REGIONNAME}</span>
                                                <h3 className='today_value'>{item.ALL_AVG}</h3>
                                                <span className='text_division_line'>|</span>
                                                <span className='today_org'>{dayData.livingArea?.EMOGERNK || dayData.livingArea?.EMOGDESC}</span>
                                                <h3 className='today_value'>{item.MY_CNT}</h3>
                                            </div>
                                            }
                                        </div>
                                    )}
                                </div>
                                <hr className='co-line'/>
                                {/* 오늘 전송건수 */}
                                <div className='flex justify-between items-end'>
                                    <div className='flex'>
                                        <div className='term_tab_box'>
                                            {termTabName.map((item, idx) => {
                                                const selected = termTab === item.en
                                                return (
                                                    <button key={idx} className={`term_tab ${selected ? 'selected_term' : ''}`} onClick={() => setTermTab(item.en)}>
                                                        {item.kr}
                                                    </button>
                                                )
                                            })}
                                        </div>
                                        <button className='refresh_btn' onClick={() => refresh(termTab)}><Icons.HomeIcoRefresh className='refresh_icon' /></button>
                                    </div>
                                    <div className='flex items-center'>
                                        <div className='flex gap-2 items-center'>
                                            <Theme.Dot16 className='ho_primary' />
                                            <p>{admin ? '전국 전송건수' : dayData.livingArea?.EMOGDESC}</p>
                                            {admin ? '' :
                                            <>
                                                <Icons.HomeChartAvg />
                                                <p>{dayData.livingArea?.REGIONNAME} 평균</p>
                                            </>
                                            }
                                        </div>
                                        <span className='text_division_line'>|</span>
                                        <p>조회 시간 : {termTab === 'day' ? dayData.livingArea?.CUR_TIME : termTab === 'month' ? monthData.livingArea?.CUR_TIME : yearData.livingArea?.CUR_TIME}</p>
                                    </div>
                                </div>
                                {/* 전송건수 차트 */}
                                {loading ? <Loading /> : 
                                    <div className={`w-full ${is17Inch ? 'h-half' : 'hp-60'}`}>
                                        <BarLineMixChart 
                                            data={termTab === 'day' ? (admin ? dayData.allDayCntList : dayData.dayCntList ) 
                                                : termTab === 'month' ? monthData.monthCntList : yearData.yearCntList} 
                                            areaName={admin ? undefined : dayData.livingArea}
                                            termTab={termTab} />
                                    </div>
                                }
                            </>
                        </div>
                    </div>
                    {/* KTAS 등급 차트 */}
                    <div className='ktas_chart_wrapper'>
                        <div className='ktas_chart_section wp-60'>
                            <div className='chart_title text-lg'>
                                <Icons.HomeIcoKtas /> KTAS 등급
                            </div>
                            {loading ? <Loading /> : 
                                <div className='w-full hp-80'>
                                    <BarChart 
                                        data={termTab === 'day' ? (admin ? dayData.allDayCntList : dayData.dayCntList) 
                                            : termTab === 'month' ? monthData.monthCntList : yearData.yearCntList}
                                        areaName={admin ? undefined : dayData.livingArea}
                                        termTab={termTab} />
                                </div>
                            }
                        </div>
                        {/* 전체 KTAS 등급 차트 */}
                        <div className='ktas_chart_section wp-40'>
                            <div className='chart_title text-lg'>
                                <Icons.HomeIcoKtas /> 전체 KTAS 등급
                            </div>
                            {loading ? <Loading /> : 
                            <div className='flex flex-row w-full h-full'>
                                <DoughnutChart 
                                    data={termTab === 'day' ? (admin ? dayData.allDayCntList : dayData.dayCntList) 
                                    : termTab === 'month' ? monthData.monthCntList : yearData.yearCntList}
                                    areaName={admin ? undefined : dayData.livingArea}
                                    termTab={termTab} />
                            </div>
                            }
                        </div>
                    </div>
                </div>
                <div className='home_division_line low_none_media_set' style={{height: '100%'}}></div>
                <div className='board_wrapper low_none_media_set'>
                    <div className='board_section'>
                        <div className='chart_title text-lg mr-1-1'>
                            <Icons.HomeIcoBoard1 /> 공지사항
                        </div>
                        <HomeBoard boardNo='11' />
                    </div>
                    <div className='board_section'>
                        <div className='chart_title text-lg mr-1-1'>
                            <Icons.HomeIcoBoard2 /> 자료실
                        </div>
                        <HomeBoard boardNo='3' />
                    </div>
                </div>
            </div>
        </Main>
    )
}

export default NewHome;